import { render, staticRenderFns } from "./labels.vue?vue&type=template&id=7cc3f9b2"
import script from "./labels.vue?vue&type=script&lang=js"
export * from "./labels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc3f9b2')) {
      api.createRecord('7cc3f9b2', component.options)
    } else {
      api.reload('7cc3f9b2', component.options)
    }
    module.hot.accept("./labels.vue?vue&type=template&id=7cc3f9b2", function () {
      api.rerender('7cc3f9b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/filter/v2/labels.vue"
export default component.exports